import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <i className="ri-error-warning-line text-6xl text-teal-600"></i>
        </div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-8">{t('common.pageNotFound')}</p>
        <button
          onClick={() => window.REACT_APP_NAVIGATE('/')}
          className="bg-teal-600 text-white px-6 py-3 rounded-full hover:bg-teal-700 transition-colors"
        >
          {t('common.backToHome')}
        </button>
      </div>
    </div>
  );
}